import setElement from 'bcl/modifiers/set-element';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import filterSort from 'bcl/helpers/filter-sort';
import eq from 'ember-truth-helpers/helpers/eq';

interface InputSelectItemsSignature {
  // The arguments accepted by the component
  Args: {};
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class InputSelectItemsComponent extends Component<InputSelectItemsSignature> {
  <template>
    <div
      class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2 col-span-6"
    >
      <label
        for={{@name}}
        class="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5 sm:text-right"
      >{{@label}}</label>
      <div class="mt-2 sm:col-span-2 sm:mt-0">
        <select
          {{setElement this.inserted}}
          {{on "change" this.change}}
          name={{@name}}
          id={{@name}}
          value={{@value}}
          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
        >
          {{#each (filterSort this.items "active" "name") as |item|}}
            <option
              value={{item.id}}
              selected={{eq item @value}}
            >{{item.name}}</option>
          {{/each}}
        </select>
      </div>
    </div>
  </template>
  @service store;
  @action
  change(event: Event) {
    if (this.args.onChange) {
      const value = event.target.value;
      const model = this.store.peekRecord('item', value);
      this.args.onChange(model);
      // this.args.onChange(...arguments);
    }
  }
  @action inserted(element: HTMLSelectElement) {
    const val = element.value;
    if (val) {
      const model = this.store.peekRecord('item', element.value);
      this.args.onChange(model);
    }
  }
  get items() {
    return this.store.peekAll('item');
  }
}
